import { jsx as _jsx } from "react/jsx-runtime";
import { useI18n } from "@/shared/hooks";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
import { Dropdown } from "@gemini/ui";
import { Controller } from "react-hook-form";
import { netMonthlyIncomeTestId } from "./constants";
import { useDropdownItems } from "./useDropdownItems";
export const NetMonthlyIncomeInput = ({ control }) => {
    const { t } = useI18n();
    const isPreviewMode = useIsPreviewMode();
    const defaultItems = useDropdownItems("contact.form.net_monthly_income", 9);
    return (_jsx(Controller, { name: "netMonthlyIncome", control: control, defaultValue: "", render: ({ fieldState: { error }, field }) => (_jsx(Dropdown, Object.assign({}, (error && {
            error: t("contact.form.net_monthly_income_error_empty"),
        }), field, { label: t("contact.form.net_monthly_income"), placeholder: t("contact.form.please_select"), testId: netMonthlyIncomeTestId, defaultItems: defaultItems, isDisabled: isPreviewMode }))) }));
};
